import {
  GET_LEGAL_ENTITIES_REQUEST,
  GET_LEGAL_ENTITIES_SUCCESS,
  GET_LEGAL_ENTITIES_FAILURE
} from 'actions';

// eslint-disable-next-line default-param-last
function legalEntities(state = {
  isGettingLegalEntities: false,
  legalEntities: [],
  legalEntitiesCount: 0
}, action) {
  switch (action.type) {
    case GET_LEGAL_ENTITIES_REQUEST:
      return {
        ...state,
        isGettingLegalEntities: action.isGettingLegalEntities
      };
    case GET_LEGAL_ENTITIES_SUCCESS:
      return {
        ...state,
        isGettingLegalEntities: action.isGettingLegalEntities,
        legalEntities: action.legalEntities,
        legalEntitiesCount: action.legalEntitiesCount
      };
    case GET_LEGAL_ENTITIES_FAILURE:
      return {
        ...state,
        isGettingLegalEntities: action.isGettingLegalEntities,
        getFormsError: action.getFormsError,
        legalEntities: [],
        legalEntitiesCount: 0
      };
    default:
      return state;
  }
}

export default legalEntities;
